import { useNavigate } from "react-router-dom";

interface HeaderProps {
  currentLocation: string;
  onLocationClick: () => void;
}

export default function Header({
  currentLocation,
  onLocationClick,
}: HeaderProps) {
  const navigate = useNavigate();

  // 直接显示完整地址，超出时省略
  const getCityName = (location: string) => {
    return location;
  };

  // const [dateRange, setDateRange] = useState({
  //   startDate: "",
  //   startTime: "",
  //   endDate: "",
  //   endTime: "",
  // });
  // const [showDatePicker, setShowDatePicker] = useState(false);

  // const handleDateClick = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   setShowDatePicker(true);
  // };

  // const handleConfirm = (range: typeof dateRange) => {
  //   setDateRange(range);
  // };

  // const formatDisplay = () => {
  //   if (!dateRange.startDate) return "选择时间";
  //   return `${dateRange.startDate} ${dateRange.startTime} ~ ${dateRange.endDate} ${dateRange.endTime}`;
  // };

  return (
    <div
      className="bg-white sticky top-0 z-40"
      style={{ boxShadow: "0 1px 0 #F3F4F6" }}
    >
      <div className="px-4 pb-3 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
          style={{ background: "#F3F4F6" }}
        >
          <i
            className="ri-arrow-left-line"
            style={{ fontSize: 20, color: "#374151" }}
          />
        </button>
        <div className="flex-1 min-w-0">
          <div
            onClick={onLocationClick}
            className="flex items-center gap-2 rounded-xl px-3 py-2"
            style={{ background: "#F3F4F6" }}
          >
            <div className="flex items-center gap-2 cursor-pointer min-w-0">
              <i
                className="ri-map-pin-line"
                style={{ color: "#D97706", fontSize: 15 }}
              />
              <span className="text-sm font-semibold text-gray-800 truncate">
                {getCityName(currentLocation)}
              </span>
            </div>
          </div>
        </div>
        <button
          className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
          style={{ background: "#F3F4F6" }}
        >
          <i
            className="ri-equalizer-2-line"
            style={{ color: "#6B7280", fontSize: 18 }}
          />
        </button>
      </div>

      {/* 日期选择器 */}
      {/* <DateTimeRangePicker */}
      {/*   visible={showDatePicker} */}
      {/*   onClose={() => setShowDatePicker(false)} */}
      {/*   onConfirm={handleConfirm} */}
      {/*   initialRange={dateRange} */}
      {/*   title="选择租车时间" */}
      {/* /> */}
    </div>
  );
}
